import { html } from 'lit';
import { REFI_PREQUAL_CONST } from '../shared/constants/app.constants.js';
import { RefiCreditpullApp } from '../app.component.js';

export class V2Softpull extends RefiCreditpullApp {
  constructor() {
    super('V2Softpull');
  }

  renderPageV2(currentState) {
    // Render based on current state
    switch (currentState) {
      case REFI_PREQUAL_CONST.V2_STATUSES.REVIEW:
        return html`<refi-prequalify-review
          class="side-padding"
          @internal-show-animation="${() => {
            this.showAnimation = true;
          }}"
          @initiate-animation-completion="${() => {
            this.initiateAnimationCompletion = true;
          }}"
        ></refi-prequalify-review>`;
      case REFI_PREQUAL_CONST.V2_STATUSES.REVIEWING:
        if (this.isIconicInvisiblePrequal) {
          return html`<iconic-under-review
            class="side-padding"
          ></iconic-under-review>`;
        }
        return html`<refi-prequal-under-review
          class="side-padding"
        ></refi-prequal-under-review>`;
      case REFI_PREQUAL_CONST.V2_STATUSES.NO_OFFER:
        if (this.isIconicInvisiblePrequal) {
          return html`<iconic-no-offer class="side-padding"></iconic-no-offer>`;
        }
        return html`<refi-prequal-no-offer
          class="side-padding"
        ></refi-prequal-no-offer>`;
      case REFI_PREQUAL_CONST.V2_STATUSES.VERIFYING:
        if (this.isIconicInvisiblePrequal) {
          return html`<iconic-verifying
            class="side-padding"
          ></iconic-verifying>`;
        }
        return html`<refi-prequal-verifying
          class="side-padding"
        ></refi-prequal-verifying>`;
      case REFI_PREQUAL_CONST.V2_STATUSES.PROCESSING:
        return html`<refi-processing-softpull
          class="side-padding"
          ?is-iconic="${this.isIconicInvisiblePrequal || this.isIconicV2}"
          @initiate-animation-completion="${() => {
            this.initiateAnimationCompletion = true;
          }}"
          @show-completion-animation="${() => {
            this.showCompletionAnimation = true;
          }}"
        ></refi-processing-softpull>`;
      case REFI_PREQUAL_CONST.V2_STATUSES.PROCESSING_PRE_APPROVAL:
        return html`<refi-prequal-processing-guaranteed-offer
          class="side-padding"
        ></refi-prequal-processing-guaranteed-offer>`;
      default:
        return html``;
    }
  }
}
customElements.define('refi-softpull', V2Softpull);
